var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 11.997H7.91766L7.91022 17.9927L3.82616 18C3.13805 17.9377 2.6731 17.3953 2.6917 16.71V9.64416L9.99688 3.05478L17.3021 9.62583L17.3132 16.7063C17.3281 17.4283 16.8111 17.9853 16.0895 18L12.0873 17.9927V11.997H12.0835Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3579 5.88772L19.7087 8.02065C20.0881 8.36515 20.0918 8.92953 19.7496 9.28136C19.4297 9.61119 18.8867 9.66983 18.485 9.30701L10.3168 1.95168C10.0825 1.74278 9.91513 1.74278 9.6808 1.95168L1.51639 9.30334C1.13328 9.64784 0.631143 9.61486 0.296384 9.318C-0.0383748 9.02115 -0.138803 8.40912 0.255469 8.05363L8.58353 0.544382C9.43159 -0.217904 10.633 -0.155602 11.4513 0.58103L14.9142 3.69248C15.089 3.26369 14.6687 2.05796 15.487 2.0543L16.7702 2.04697C17.079 2.04697 17.3654 2.3145 17.3654 2.61868L17.3542 5.88772H17.3579Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.a5f2666091f48b3097513b8ba05641f1.svg";
export { ForwardRef as ReactComponent };